<template>
  <el-dialog
    title="会员提升及阶梯收益设置"
    :visible.sync="visible"
    width="520px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :rules="rules"
      :model="ruleForm"
      label-width="110px">
      <el-form-item
        label="升级消费金额:"
        prop="levelAmount">
        <el-input-number
          v-model="ruleForm.levelAmount"
          :min="0"
          :precision="0"
          :max="99999999"></el-input-number>元
      </el-form-item>
      <el-form-item
        label="升级返现金额:"
        prop="levelUpgradeGiveAmount">
        <el-input-number
          v-model="ruleForm.levelUpgradeGiveAmount"
          :min="0"
          :precision="0"
          :max="99999999"></el-input-number>元
      </el-form-item>
      <el-form-item
        label="阶梯收益信息:"
        prop="shopIncentiveSteps">
        <div
          v-for="(item, index) in ruleForm.shopIncentiveSteps"
          :key="index">
          <div>
            <span>消费{{ index === 0 ? 0 : ruleForm.shopIncentiveSteps[index-1].totalAmount }}-{{ item.totalAmount }}元，{{ item.cashbackPercent }}%的返现和{{ item.commissionPercent }}%的提成</span>
            <i
              class="el-icon-edit"
              style="cursor: pointer;color: #409EFF;margin-left: 5px;"
              @click="editSteps(item, index)"></i>
            <i
              class="el-icon-delete"
              style="cursor: pointer;color: #f56c6c;margin-left: 5px;"
              @click="deleteSteps(index)"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="addSteps">新增阶梯收益分段</el-button>
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </template>
    <vip-upgrade-info-modal
      ref="info"
      @update="onUpdate" />
  </el-dialog>
</template>
<script>
import VipUpgradeInfoModal from './vip-upgrade-info-modal.vue'
import _ from 'lodash'
export default {
  name: 'VipUpgradeModal',
  components: { VipUpgradeInfoModal },
  data() {
    return {
      loading: false,
      visible: false,
      postForm: {},
      editIndex: -1,
      ruleForm: { levelAmount: 0, levelUpgradeGiveAmount: 0, shopIncentiveSteps: [] }, // {totalAmount:0,cashbackPercent:0,commissionPercent}
      rules: {
        levelAmount: [
          { required: true, message: '请填写升级消费金额', trigger: 'blur' }
        ],
        levelUpgradeGiveAmount: [
          { required: true, message: '请填写升级返现金额', trigger: 'blur' }
        ],
        shopIncentiveSteps: [
          { required: false, message: '请添加阶梯收益', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    deleteSteps(index) {
      this.ruleForm.shopIncentiveSteps.splice(index, 1)
    },
    editSteps(item, index) {
      this.editIndex = index
      this.$refs.info.init(item)
    },
    addSteps() {
      this.$refs.info.init()
    },
    onUpdate(row, ctx) {
      const steps = _.cloneDeep(this.ruleForm.shopIncentiveSteps)
      if (this.editIndex > -1) {
        steps.splice(this.editIndex, 1)
      }
      if (steps.find(i => i.totalAmount === row.totalAmount)) {
        this.$message.error('分段金额已存在')
        return
      }
      this.editIndex = -1
      steps.push(row)
      steps.sort((a, b) => a.totalAmount - b.totalAmount)
      this.ruleForm.shopIncentiveSteps = steps
      ctx.visible = false
    },
    handleClose() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
      this.postForm = {}
    },
    handleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('member/updatememberlevel', {
            payload: { ...this.postForm, ...this.ruleForm },
            success: () => {
              this.$emit('fetch')
              this.loading = false
              this.visible = false
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    init(options = {}, postForm) {
      this.postForm = postForm
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
